import React from 'react';
import about from '../images/about_org.jpg';
import account from '../images/accounts.jpg';
import { useDocTitle } from '../components/CustomHook';
import CommonContainer from "../components/CommonContainer";
import { commonStyles } from "../pages/commonStyles";
function Accounting() {
  useDocTitle('Accounting');

  return (
    <div>
      {/* Hero Section */}
     <div className="relative overflow-hidden mt-4 lg:mt-0 h-[320px] md:h-[380px] lg:h-[450px]">
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          <img
            src={about}
            alt="Background"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-50 z-10"></div>

        {/* Hero Content */}
       <div className="relative z-20 h-full flex items-center justify-center text-center text-white">
 <h2 className={`${commonStyles.pageTitle} text-white`}>
    Accounting
  </h2>
</div>
      </div>
<CommonContainer>
      {/* Section Title */}
      <div className="text-center mt-10">
        <h1 className={`${commonStyles.heading} mb-6`}>
          Accounting Services
        </h1>
      </div>

      {/* Main Content */}
     <div className="mt-16 flex flex-col lg:flex-row items-center gap-8">
        {/* Left Text */}
       <div className="lg:w-1/2">
          <ul className="space-y-4 md:space-y-6 ml-6 md:ml-12 lg:ml-18">
            {[
              'General Bookkeeping',
              'Accounts Payable',
              'Accounts Receivable',
              'Bank Reconciliation',
              'Balance Sheet',
              'Customized Reports',
              'Detailed General Ledgers',
              'Financial Statements',
              'Payroll and Check Registers',
              'Additional Feature - Cloud Storage',
              'Accounting Software - Sage 50',
              'Autoentry',
            ].map((item) => (
              <li
                key={item}
               className="flex items-start text-[20px] leading-8 text-gray-600 mt-0"
              >
               <span className="text-green-500 text-xl mr-3 mt-1">✔</span>
                {item}
              </li>
            ))}
          </ul>
        </div>

        {/* Right Image */}
        <div className="lg:w-1/2">
          <img
            src={account}
            alt="Accounting Details"
           className="w-full h-auto object-cover rounded-xl shadow-lg"
          />
        </div>
      </div>
      </CommonContainer>
    </div>
  );
}

export default Accounting;
